(function () {
    'use strict';

    angular.module('app').directive('fodbzHelpedDropdownRequired', ComboboxDirective);

    ComboboxDirective.$inject = [];
    function ComboboxDirective() {
        return {
            transclude: true,
            // eslint-disable-next-line angular/no-directive-replace
            replace: true,
            scope: {
                fodbzModel: '=',
                fodbzFieldConst: '@',
                fodbzInfoTitle: '@',
                fodbzInfo: '@',
                organisationTypes: '=',
                fodbzInit: '@',
                fodbzDisabled: '=',
            },
            template: `
            <div class="form-horizontal">
                <div class="input-group">
                    <div class="input-group-addon ">
                        <span data-toggle="popover"
                              title="{{fodbzInfo}}"
                              data-content="{{fodbzInfo}}"
                              style="cursor:pointer"
                              data-original-title="{{fodbzInfoTitle}}">
                              <span class="glyphicon glyphicon-info-sign" style="font-size:75%; vertical-align: center;"></span>
                        </span>
                    </div>
                    <fodbz-dropdown-required fodbz-model="fodbzModel"
                                             fodbz-field-const="{{fodbzFieldConst}}"
                                             organisation-types="organisationTypes"
                                             fodbz-init="{{fodbzInit}}"
                                             fodbz-disabled="fodbzDisabled">
                    </fodbz-dropdown-required>
                </div>
            </div>`,
        };
    }
})();